import { MAX_WIDTH_MOBILE } from '@utils';

export const Responsive = {
  MOBILE: `max-width: ${MAX_WIDTH_MOBILE}px`,
};

export const Media = {
  mobile: `@media screen and (max-width: ${MAX_WIDTH_MOBILE}px)`,
};
